export default __webpack_public_path__ + "static/media/double-border-both.875dd7b4.svg";